import type {
  FiltroSituacaoCotacao,
  OrdenarCotacoesReferenciaPor,
} from "@/modules/financeiro-configuracoes";

export const MOEDAS_TITULO = "Cadastro de moedas";
export const MOEDAS_DESCRICAO =
  "Cotação de referência de cada moeda por mês, usada no Outlook. Se houver mais de uma no mesmo mês, vale a cadastrada por último. Cadastrar, inativar ou ativar uma cotação não muda os custos nem as projeções das Obras. Meses futuros também podem ser cadastrados e ficam com a tag Futura.";

export const MOEDAS_NOVA_COTACAO_LABEL = "Nova cotação";
export const MOEDAS_VAZIO_TITULO = "Nenhuma cotação cadastrada";
export const MOEDAS_VAZIO_DESCRICAO = "As cotações cadastradas aqui são usadas no Outlook.";
export const MOEDAS_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar as cotações de referência.";
export const MOEDAS_ERROR_MESSAGE = "Não foi possível carregar as cotações de referência.";
export const MOEDAS_LOADING_LABEL = "Carregando cotações...";
export const MOEDAS_EXPORT_INDISPONIVEL = "Exportação indisponível nesta tela";
export const MOEDAS_ROWS_PER_PAGE_LABEL = "Cotações por página";
export const MOEDAS_TABLE_LABEL = "Cotações de referência";

export const MOEDAS_TAG_REFERENCIA_ATUAL = "Referência atual";
export const MOEDAS_TAG_FUTURA = "Futura";
export const MOEDAS_TAG_INATIVA = "Inativa";

export const MOEDAS_FILTRO_MOEDA_ROTULO = "Moeda";
export const MOEDAS_FILTRO_SITUACAO_ROTULO = "Situação";
export const MOEDAS_FILTRO_TODAS = "Todas";

/** Valor do filtro de moeda sem seleção. */
export const MOEDA_TODAS = "";

export const SITUACAO_PADRAO: FiltroSituacaoCotacao = "ATIVAS";
export const SITUACAO_OPCOES: readonly { label: string; value: FiltroSituacaoCotacao }[] = [
  { label: "Ativas", value: "ATIVAS" },
  { label: "Inativas", value: "INATIVAS" },
  { label: "Todas", value: "TODAS" },
];

export type MoedasColumnKey = OrdenarCotacoesReferenciaPor | "acoes";

/** Colunas na ordem do Figma (16178:338871); a competência ocupa o que sobra, as demais têm a largura do protótipo. */
export const MOEDAS_COLUNAS = [
  { key: "competencia", header: "Competência", widthRem: undefined, align: undefined },
  { key: "moeda", header: "Moeda", widthRem: 12.5, align: undefined },
  { key: "cotacao", header: "Cotação (R$)", widthRem: 8.125, align: "right" },
  { key: "cadastradaEm", header: "Cadastrada em", widthRem: 10.625, align: undefined },
] as const;

export const MOEDAS_ACOES_KEY = "acoes";
export const MOEDAS_ACOES_WIDTH_REM = 3.75;

export const MOEDAS_ALL_COLUMNS: readonly MoedasColumnKey[] = [
  ...MOEDAS_COLUNAS.map(({ key }) => key),
  MOEDAS_ACOES_KEY,
];

/** Abaixo desta largura a tabela rola na horizontal (mobile: tabela de 760). */
export const MOEDAS_TABLE_MIN_WIDTH = "47.5rem";
